module.exports = __webpack_public_path__ + "img/position.ec99e4dc.png";